import { addAuthInterceptors } from '@dentalux/security';
import axios from 'axios';
const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_RECOMMENDATION_BACKEND_URL
});
addAuthInterceptors(http);
export const getPersonRecommendations = async ({
  personReferenceId,
  ...params
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/recommendations`, {
    params
  });
  return data;
};
export const ignoreRecommendation = async ({
  referenceId,
  personReferenceId,
  ...body
}) => {
  const {
    data
  } = await http.patch(`/external/persons/${personReferenceId}/recommendations/${referenceId}/ignored`, body);
  return data;
};